export default __webpack_public_path__ + "static/media/cakes.333cbd50.webp";